import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts'
import type { TimelinePoint } from '../types'

interface ActivityTimelineChartProps {
  data: TimelinePoint[]
  title: string
  height?: number
}

export default function ActivityTimelineChart({ data, title, height = 120 }: ActivityTimelineChartProps) {
  if (data.length === 0) {
    return (
      <div className="border border-border rounded-lg p-4">
        <p className="text-sm font-medium text-muted-foreground mb-3">{title}</p>
        <div className="flex items-center justify-center" style={{ height }}>
          <p className="text-sm text-muted-foreground">Nenhum dado no período</p>
        </div>
      </div>
    )
  }

  return (
    <div className="border border-border rounded-lg p-4">
      <p className="text-sm font-medium text-muted-foreground mb-3">{title}</p>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={data}>
          <XAxis
            dataKey="date"
            tick={{ fontSize: 10 }}
            tickFormatter={(d: string) => new Date(d).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })}
          />
          <YAxis tick={{ fontSize: 10 }} width={30} allowDecimals={false} />
          <Tooltip
            labelFormatter={(d) => new Date(String(d)).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit' })}
            formatter={(value) => [`${value} sessões`, '']}
          />
          <Bar dataKey="sessions" fill="#3b82f6" radius={[2, 2, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
